import { Dropdown, ErrorContainer, LabelComponent } from 'components';
import { useFormikContext } from 'formik';
import { useAppSelector } from 'store/hooks';

const Manager = ({ disabled }: { disabled: boolean }) => {
  const formik = useFormikContext<{
    managerId: string;
  }>();

  const managers = useAppSelector((state) => state.clients.managers.data);

  return (
    <>
      <LabelComponent text="Manager" mandatory />
      <Dropdown
        data={managers.map((manager) => ({
          id: manager.id.toString(),
          name: manager.name,
          category: manager.active ? 'ACTIVE' : 'INACTIVE'
        }))}
        label="Select"
        name="managerId"
        value={formik.values.managerId}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        disabled={disabled}
        withGradient
        categoryList={[
          { id: 'ACTIVE', label: 'Active' },
          { id: 'INACTIVE', label: 'Inactive' }
        ]}
      />
      <ErrorContainer
        errors={formik.errors}
        visible={formik.touched.managerId && formik.errors.managerId}
        name="managerId"
      />
    </>
  );
};

export default Manager;
